import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "survey",
            component: () => import("./views/Survey.vue")
        },
        {
            path: "/auth",
            name: "auth",
            component: () => import("./views/Auth.vue")
        },
        {
            path: "/success",
            name: "success",
            component: () => import("./views/Success.vue")
        },
        {
            path: "/visit",
            name: "reservationInAppSchool",
            component: () => import("./views/reservation/AppSelectSchool.vue")
        },
        {
            path: "/schools/:school/visit/app/personal",
            name: "reservationInAppPersonal",
            component: () => import("./views/reservation/AppPersonalInfo.vue")
        },
        {
            path: "/schools/:school/visit",
            name: "reservationExternalPersonal",
            component: () => import("./views/reservation/ExternalPersonalInfo.vue")
        },
        {
            path: "/schools/:school/visit/external/auth",
            name: "reservationExternalAuth",
            component: () => import("./views/reservation/ExternalSmsAuth.vue")
        },
        {
            path: "/schools/:school/visit/apply",
            name: "reservationApply",
            component: () => import("./views/reservation/ReservationForm.vue")
        },
        {
            path: "/schools/:school/visit/apply/success",
            name: "reservationApplySuccess",
            component: () => import("./views/reservation/ReservationComplete.vue")
        },
        {
            path: "/schools/:school/visit/history",
            name: "reservationHistory",
            component: () => import("./views/reservation/ReservationHistory.vue")
        },
        {
            path: "/schools/:school/visit/history/:id",
            name: "reservationHistoryDetail",
            component: () => import("./views/reservation/ReservationHistoryDetail.vue")
        },
        {
            path: "/schools/:school/visit/history/:id/cancel",
            name: "reservationCancel",
            component: () => import("./views/reservation/ReservationCancel.vue")
        },
        {
            path: "/schools/:school/unused",
            name: "reservationUnused",
            component: () => import("./views/reservation/UnusedSchool.vue")
        },
        {
            path: "/teachers/reservations/:id",
            name: "reservationTeacherDetail",
            component: () => import("./views/reservation/ReservationTeacherDetail.vue")
        },
    ]
});

export default router;
